import { Form, Modal, Select } from 'antd';
import React, { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'react-bootstrap';
import { useTicketGroups } from 'pages/store';

const AddNewSubcat = ({ subcategoryMap, groupNameOption }) => {
    const { addGroupToSubcategory } = useTicketGroups();
    const [selectedSubcat, setSelectedSubcat] = useState('')
    const [selectedGroupId, setSelectedGroupId] = useState('')

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        const selectedGroupData = subcategoryMap
            .map(group => selectedSubcat.includes(group.value) && {
                sub_category: group.value,
                sub_cat_display_name: group.label,
                group_id: selectedGroupId
            })
            .filter(Boolean);
        addGroupToSubcategory({groupData: selectedGroupData, action: 'Created and Assigned'});
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    return (
        <div className='d-flex justify-content-end'>
            <>
                <Button className='p-2' type="primary" onClick={showModal}>
                    <PlusOutlined /> Create New Subcategory Group
                </Button>
                <Modal
                    destroyOnClose
                    title="Create New Subcategory Group"
                    open={isModalOpen}
                    onOk={handleOk}
                    okButtonProps={{ disabled: !selectedGroupId || !selectedSubcat }}
                    okText={'Submit'}
                    onCancel={handleCancel}
                >
                    <Form className='pt-4'>
                        <Form.Item className='' label="Subcategory">
                            <Select
                                mode="multiple"
                                allowClear
                                showSearch
                                placeholder="Select a group"
                                optionFilterProp="children"
                                filterOption={filterOption}
                                options={subcategoryMap}
                                onChange={(value) => {
                                    setSelectedSubcat(value);
                                }}
                            />
                        </Form.Item>
                        <Form.Item className='' label="Group Name">
                            <Select
                                allowClear
                                showSearch
                                placeholder="Select a group"
                                optionFilterProp="children"
                                filterOption={filterOption}
                                options={groupNameOption}
                                onChange={(value) => {
                                    setSelectedGroupId(value);
                                }}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        </div>
    );
}

export default AddNewSubcat